// src/antdviews/components/AccountDetailContent.tsx
// 账户详情组件 - Ant Design TypeScript版本

import React from 'react'
import { Tabs, Layout } from 'antd'
import { Global } from '../../services/Global'
import { browserUtil } from '../../utils/BrowserUtil'
import AccountInfoTab from './account.detail/AccountInfoTab'
import RecordListTab from './account.detail/RecordListTab'
import LogListTab from './account.detail/LogListTab'

const { Content } = Layout
const { TabPane } = Tabs

export interface PhoneInfo {
    phoneMode: string
    phoneManufacturer: string
    phoneVersion: string
    phoneSDK: string
    hasPhoneMode: boolean
    hasPhoneManufacturer: boolean
    hasPhoneVersion: boolean
    hasPhoneSDK: boolean
}

export interface UserItem {
    user_id: string
    name: string
    middleName?: string
    lastName?: string
    gender: number
    genderStr: string
    age: number
    birthday: string
    created: string
    online_portrait?: string
    yearBirth?: number
    monthBirth?: number
    dayBirth?: number
}

export interface RecordItem {
    url: string
    fileName: string
    nickname: string
    device: string
    size: string
    startTime: string
    timeLength: string
    sourceStr: string
    description?: string
    href: string
    reports: Array<{ name: string; type: number }>
    decodeProgress: number
    rate: number
    meta: any
    location: number
    source: number
    reportTypes: number
}

export interface LogItem {
    id: string
    date: string
    size: string
    updateTime: string
    source: number
    filePath: string
    fileName: string
    uuid: string
    rowspan: number
    hideDate?: boolean
}

export interface DetailData {
    isActive: boolean
    accountName: string
    accountEmail: string
    onlinePortrait: string | null
    users: { list: UserItem[]; totalPages?: number; currentPage?: number; totalRecords?: number; pages?: number[] }
    logs: { list: LogItem[]; totalPages?: number; currentPage?: number; totalRecords?: number; pages?: number[] }
    records: { list: RecordItem[]; totalPages?: number; currentPage?: number; totalRecords?: number; pages?: number[] }
    phoneInfo: PhoneInfo
}

export interface PagedList<T> {
    list: T[]
    totalPages?: number
    currentPage?: number
    totalRecords?: number
    pages?: number[]
}

export interface AccountDetailContentProps {
    detail: DetailData
    trans: (key: string) => string
    handleConfirm: (title: string, info: string, op: Function) => void
    handleError: (title: string, info: string) => void
    notify: (msg: string) => void
    changeRecordList: (size: number, page: number) => void
    changeLogList: (size: number, page: number) => void
}

interface AccountDetailContentState {
    activeTab: string
}

export default class AccountDetailContent extends React.Component<AccountDetailContentProps, AccountDetailContentState> {

    constructor(props: AccountDetailContentProps) {
        super(props)
        this.state = {
            activeTab: 'info'
        }
    }

    componentWillMount() {
        Global.isMobile = browserUtil.checkMobile()
    }

    handleTabChange = (key: string) => {
        this.setState({ activeTab: key })
    }

    render() {
        const t = this.props.trans
        const { detail } = this.props

        return (
            <Content
                style={{
                    margin: '4px',
                    padding: '6px',
                    background: 'var(--content-bg)',
                    minHeight: '280px',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Tabs activeKey={this.state.activeTab} onChange={this.handleTabChange}>
                    <TabPane tab={t('accountInfo')} key="info">
                        <AccountInfoTab
                            detail={detail}
                            trans={t}
                        />
                    </TabPane>
                    <TabPane tab={t('recordList')} key="records">
                        <RecordListTab
                            detail={detail}
                            trans={t}
                            handleConfirm={this.props.handleConfirm}
                            handleError={this.props.handleError}
                            notify={this.props.notify}
                            changeRecordList={this.props.changeRecordList}
                        />
                    </TabPane>
                    <TabPane tab={t('logList')} key="logs">
                        <LogListTab
                            detail={detail}
                            trans={t}
                            changeLogList={this.props.changeLogList}
                        />
                    </TabPane>
                </Tabs>
            </Content>
        )
    }
}